import BlankItem from '@components/blank/BlankItem';
import Loading from '@components/Loading';
import { Fragment, useContext } from 'react';

import useItems from './hooks/useItems';
import Item from './Item';
import styles from './styles.module.scss';
import ShopItemContext from '../../../../context/ShopItemContext';

interface Props {
    columns: number;
}

function ItemGrid({ columns }:Props) {
  const { shopId } = useContext(ShopItemContext);
  const { items, isLoading, isBlank } = useItems();
  return (
        <Fragment>
          {isBlank && (
              <BlankItem/>
          )}
            {isLoading && (
                <Loading size='small'/>
            )}
          <section className={`${styles.container} ${styles[`col-${columns}`]}`}>
            {items?.map((item) => (
                <Item item={item}
                      shopId={shopId}
                      key={item.id} />
            ))}
          </section>
        </Fragment>
  );
}

export default ItemGrid;
